import axios from "axios";

const loadAbort = () => {
  return new AbortController();
};

export const getCustomerInfo = (token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "get",
        url: `${urlService}/user/v1/customer/info`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};


  export const editProfileCustomer = (form: any, token: string) => {
    const controller = loadAbort();
    return {
      call: (urlService: string) => axios({
          method: "put",
          url: `${urlService}/user/v1/customer/info`,
          data: JSON.stringify(form),
          headers: {
            "Content-Type": "application/json",
             Authorization: `Bearer ${token}`,
          },
        }),
      controller,
    };
  };

    export const sendOTPCustomer = (form: any, token: string) => {
    const controller = loadAbort();
    return {
      call: (urlService: string) => axios({
          method: "post",
          url: `${urlService}/user/v1/customer/send-otp`,
          data: JSON.stringify(form),
          headers: {
            "Content-Type": "application/json",
             Authorization: `Bearer ${token}`,
          },
        }),
      controller,
    };
  };

  //user/v1/customer/validate-otp

  export const validateCustomerOTP = (form: any, token: string) => {
    const controller = loadAbort();
    return {
      call: (urlService: string) => axios({
          method: "post",
          url: `${urlService}/user/v1/customer/validate-otp`,
          data: JSON.stringify(form),
          headers: {
            "Content-Type": "application/json",
             Authorization: `Bearer ${token}`,
          },
        }),
      controller,
    };
  };